var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsersIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 26,
    viewBox: "0 0 30 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.076 7.54541C12.5538 7.54541 10.8302 9.44699 11.2436 11.7708L11.8742 15.2892C12.1229 16.6835 13.5627 17.8257 15.076 17.8257C16.5894 17.8257 18.0327 16.6868 18.2779 15.2892L18.905 11.7708C19.3183 9.44699 17.5948 7.54541 15.0725 7.54541H15.076Z",
    stroke: "#3A77BC",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9373 19.4488L18.5514 18.084C17.63 18.9251 16.3899 19.4619 15.0763 19.4619C13.7626 19.4619 12.5225 18.9251 11.6012 18.084L7.21172 19.4488C6.39899 19.7008 5.7334 20.5649 5.7334 21.3635V24.9997H24.4156V21.3635C24.4156 20.5649 23.75 19.7008 22.9373 19.4488Z",
    stroke: "#3A77BC",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7462 5.36279C18.7023 5.36279 17.8055 5.70318 17.1294 6.25303C18.0227 6.55742 18.8179 7.05818 19.4275 7.72914C20.4784 8.88449 20.9163 10.4555 20.6325 12.0396L20.0055 15.558C20.002 15.5777 19.9915 15.6006 19.988 15.6202C21.4102 15.5057 22.7134 14.4256 22.9481 13.1066L23.5752 9.58817C23.9885 7.26438 22.265 5.36279 19.7462 5.36279Z",
    stroke: "#B4D334",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7218 7.72918C11.5696 6.79639 12.7641 6.1909 14.0988 5.99125L14.2354 5.22538C14.6523 2.90158 12.9253 1 10.4065 1C7.88776 1 6.16072 2.90158 6.57409 5.22538L7.20465 8.7438C7.39732 9.83696 8.32566 10.7632 9.44316 11.12C9.43965 9.85987 9.88105 8.66197 10.7218 7.72918Z",
    stroke: "#3A77BC",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.65481 17.8981L10.5398 16.6903C10.3611 16.3303 10.214 15.9572 10.1439 15.5612L9.6605 12.8446C8.62708 12.6843 7.67422 12.2195 6.92806 11.542L2.53863 12.9068C1.7259 13.1588 1.0603 14.0229 1.0603 14.8215V18.4577H5.56183C5.89113 18.2155 6.25896 18.0224 6.65481 17.8981Z",
    stroke: "#3A77BC",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.607 17.5699L23.221 15.9014C22.5905 16.4741 21.8093 16.8931 20.958 17.1091L23.4908 17.8979C25.0181 18.3757 26.1672 19.8649 26.1672 21.3672V22.8204H29.0853V19.1841C29.0853 18.3855 28.4197 17.8219 27.607 17.5699Z",
    stroke: "#B4D334",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersIcon);
export default __webpack_public_path__ + "static/media/UsersIcon.c4d78b51f4bb5f15c2e6930acad758ef.svg";
export { ForwardRef as ReactComponent };